import KendoListBox from '../KendoListBox'

let KendoListBoxInstaller = class {
    static install(Vue) {
        Vue.component(KendoListBox.name, KendoListBox)
    }
}

export default KendoListBoxInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoListBoxInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-listbox-vue-wrapper/src/kendo-listbox-installer/index.js